module.exports = __webpack_public_path__ + "9f1ae309.png";